import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { KTSVG } from "../../../smallnation/helpers"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { set, useForm } from "react-hook-form";
//import { default as ReactSelect } from "react-select";
//import { components } from "react-select";

import { ColourOption, colourOptions } from "./data";
import { components } from "react-select";
import ReactSelect, { OptionProps } from 'react-select';

//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"
const Option = (props) => {
  return (
      <div>
          {
              //console.log("results=="+JSON.stringify(props))
          }
          <components.Option {...props}>
              <input
                  type="checkbox"
                  checked={props.isSelected}
                  onChange={() => null}
              />{" "}
              <label>{props.label}</label>
          </components.Option>
      </div>
  );
};





const CompanyReport: FC = () => {
      const intl = useIntl()

      const ITEMS_PER_PAGE = 50; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      const [jobfilterlist, setJobFilterList] = useState([]);
      const [locationCounty, setLocationCounty] = useState([]);
  const [jobTypes, setJobType] = useState([]);
  const [educations, setEducation] = useState([]);
  const [categories, setCategory] = useState([]);
  const [mullocationCounty, setMulLocationCounty] = useState([]);
  const [mullocationCountyselected_d, setMulLocationCountyOptionSelectedd] = useState([]);
  const [locationRequestArray_d, setLocationRequestArrayd] = useState([]);
  const [mulcategories_d, setMulCategory_d] = useState([]);
  const [industryRequestArray_d, setIndustryRequestArrayd] = useState([]);
  const [optionCatSelected_d, setoptionCatSelectedd] = useState(null);

  const [reportStatus, setReportStatus] = useState('');
  const [reportIndustry, setReportIndustry] = useState('');
  const [reportLocation, setReportLocation] = useState('');
  const [reportJobshadow, setReportJobShadow] = useState('');
  const [runReport, setRunReport]= useState<any>(0);

  var FileSaver = require('file-saver');


  ////////////


  var industry_webvar = [];
  var location_webvar = [];
      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all", mode: "onBlur"
      });

      const handleChangeForCate_d = (selected) => {
        //alert();
        var dummArray = [];
        var dummArray_label = '';
        for (var i = 0; i < selected.length; i++) {
            //alert(selected[i].label.toString());
            dummArray.push(selected[i].value.toString());
            if(i==0){
              dummArray_label = selected[i].label.toString();
            } else{
              dummArray_label = dummArray_label+', '+selected[i].label.toString();
            }
            industry_webvar.push(selected[i].value.toString());
        }
        setIndustryRequestArrayd(dummArray);
        //industry_webvar = dummArray;
        $('#industry_selected').val(JSON.stringify(dummArray));
        $('#industry_selfilter').val(dummArray_label);
        setoptionCatSelectedd(selected);
        setReportIndustry(dummArray_label);
    };

      useEffect(() =>
      {
        getIndustryData();
        $(".load-wrap").hide();
        services.getLocationCounty().then((res) => {
          setLocationCounty(res.data.content);
          // alert(res.data.content.length)
          var dummArray = [];
          for (var i = 0; i < res.data.content.length; i++) {
              dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].jobLocationCountyId })
          }
          setMulLocationCounty(dummArray);
        });
        services.getJobType().then((res) => {
        /* console.log("setJobType data=" + JSON.stringify(res.data));
          setJobType(res.data.content); */

          var jobtype_unsort = res.data.content;
          var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
          array_move(jobtypes_sorted, 0, (jobtypes_sorted.length-1));
          setJobType(jobtypes_sorted);

        });
        services.getEducation().then((res) => {
          console.log("getEducation data=" + JSON.stringify(res.data));
          setEducation(res.data.content);
        });
        //getjobslist(ITEMS_PER_PAGE,'1');

        $(function(){
          $(".new-scrl-tbl").scroll(function(){
            $(".new-scrl-tbl2").scrollLeft($(".new-scrl-tbl").scrollLeft());
          });
          $(".new-scrl-tbl2").scroll(function(){
            $(".new-scrl-tbl").scrollLeft($(".new-scrl-tbl2").scrollLeft());
          });
        });




      },[]);

      function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };

      const getIndustryData = () => {
        services.getIndustryData().then((res) => {
          setCategory(res.data.content);
          var dummArray = [];
          for (var i = 0; i < res.data.content.length; i++) {
              dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].catId })
          }
          setMulCategory_d(dummArray)
        });
      }
      const submitValue = () => {
        getjobslist(ITEMS_PER_PAGE,'1');
      }
      const searchList = () => {
       getjobslist(ITEMS_PER_PAGE,'1');
      }

      function validateCheck() {

    }

    const handleChangeForLocation_d = (selected) => {
      var dummArray = [];
      var dummArray_label = '';
      for (var i = 0; i < selected.length; i++) {
          dummArray.push(selected[i].value.toString());
          if(i==0){
            dummArray_label = selected[i].label.toString();
          }
          else{
            dummArray_label = dummArray_label+', '+selected[i].label.toString();
          }
          location_webvar.push(selected[i].value.toString());
      }
      setMulLocationCountyOptionSelectedd(selected);
      //location_webvar = dummArray;
      $('#location_selected').val(JSON.stringify(dummArray));
      $('#location_selfilter').val(dummArray_label);
      setLocationRequestArrayd(dummArray);
      setReportLocation(dummArray_label);

  };

  const filterContent_full = () => {
    var industries_filter:any = [];
        var selected_ind:any = $('#industry_selected').val();
        if (selected_ind != '') {
            var industries_filter = JSON.parse(selected_ind);
        }


        var locations_filter:any = [];
        var selected_loc:any = $('#location_selected').val();
        if (selected_loc != '') {
            var locations_filter = JSON.parse(selected_loc);
        }


        if($('#job_shadow').val() == 'Y'){
          setReportJobShadow('Yes');
        } else if($('#job_shadow').val() == 'N') {
          setReportJobShadow('No');
        } else {

        }

 //setReportLocation($('#location_selfilter').val());
 //setReportIndustry($('#industry_selfilter').val());
 var cstatus:any = $('#company_status').val();
 setReportStatus(cstatus);

        const requestObject = {
            "industrycategory":industries_filter,
            "companyLocation":locations_filter,
            "siteId":2,
            "jobShadowStatus":$('#job_shadow').val(),
            "status":$('#company_status').val(),
            "searchTxt":$('#job_title').val(),
            "pageSize": 50000,
            "pageNumber": 1,
            "sortBy": "",
            "sortDir":""
        }
        // console.log(JSON.stringify(objInputAvailableJobs));
        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
          },
          body: JSON.stringify(requestObject)
        };
        $(".load-wrap").show();
        services.getCompanyReportList(requestOptions).then((res) => {
      console.log(JSON.stringify(res.content))
      if (res) {

            var contAr = res.content;

            //setJobFilterList(res.content);
              download_excel(contAr);
       }

    });

}

function download_excel(profileListFull){
  //console.log(profileListFull);

  var today = new Date();
  var month = today.toLocaleString('en-US', {month: 'short'});
  var date= today.getDate();
  var year = today.getFullYear();

  var filename = "Companies-export-"+month+"-"+date+"-"+year+".csv";
 // console.log(filename);
  let csv = '';
  let row = '';
  let headers = '';


  var row2 = '';
  if (reportStatus != '')
      row2 = row2+'Status : '+reportStatus.replace(/,/g, ";");

  if(reportStatus != '' && reportJobshadow != '')
      row2 = row2+';      ';

  if (reportJobshadow != '')
      row2 = row2+'Job Shadow Opportunity : '+reportJobshadow.replace(/,/g, ";");

  if(reportJobshadow != '' && reportLocation != '')
      row2 = row2+';      ';

  if (reportLocation != '')
      row2 = row2+'County : '+reportLocation.replace(/,/g, ";");

  if(reportLocation != '' && reportIndustry != '')
      row2 = row2+';      ';

  if (reportIndustry != '')
      row2 = row2+'Industry : '+reportIndustry.replace(/,/g, ";");


  var jobtypeslisthead = 'Companies Report'+',';
  var jobtypeslisthead = jobtypeslisthead+'\n'+row2+',';
 var jobtypeslisthead = jobtypeslisthead+'\n'+'Name'+','+'Address'+','+'City'+','+'State'+','+'Zip'+','+'County'+','+'Email'+','+'Phone'+','+'Website'+','+'# Employees'+','+'Job Shadow'+','+'Status'+','+'Company URL'+',';

  headers = headers.concat(jobtypeslisthead);

  csv = csv.concat(headers);
  row = '';

  for(var i=0; i<profileListFull.length; i++){

          var jobtypeslistrow = "";

          var companyname = profileListFull[i].companyName;
          companyname = companyname.replace(/,/g, ";");

          var jobshadow = profileListFull[i].jobShadowConcert;
          if(jobshadow == 'Y'){
            var jobshadowval = 'Yes';
          }
          else if(jobshadow == 'N'){
            var jobshadowval = 'No';
          } else {
            var jobshadowval = '--';
          }
          var companyurl = process.env.React_App_PUBLIC_URL+"companyDetails?companyId="+profileListFull[i].companyId;

          var address1 = profileListFull[i].address1;
          address1 = address1.replace(/,/g, ";");

          var address2 = profileListFull[i].address2;
          address2 = address2.replace(/,/g, ";");

          var city = profileListFull[i].city;
          city = city.replace(/,/g, ";");

          var state = profileListFull[i].state;
          state = state.replace(/,/g, ";");

          if(profileListFull[i].phone == '0000000000' || profileListFull[i].phone == '0'){
            var phone:any = '000-000-0000';
          }
          else {
            var phone:any = profileListFull[i].phone;
          }

          var addressfield='';
          if(address1 != ''){
            addressfield = addressfield+address1;
          }
          if(address1 !='' && address2 != ''){
            addressfield = addressfield+' ; ';
          }
          if(address2 != ''){
            addressfield = addressfield+address2;
          }

         jobtypeslistrow = "\n"+companyname+","+addressfield+','+city+','+state+','+profileListFull[i].zip+','+profileListFull[i].countyName+','+profileListFull[i].email+','+phone+','+profileListFull[i].webSite+','+profileListFull[i].employeeCount+','+jobshadowval+','+profileListFull[i].status+','+companyurl+',';


      row = row.concat(jobtypeslistrow);

  }
  csv = csv.concat(row);

  var file = new File([csv], filename, {type: "application/csv"});
  FileSaver.saveAs(file);
  $(".load-wrap").hide();
}

function displayJobShadowval(jobshadow){
  if(jobshadow == 'Y'){
    return 'Yes';
  }
  else if(jobshadow == 'N'){
    return 'No';
  }
  else {
    return '--';
  }
}

      const handlePageChange2 = (offset,triggerevent) => {
        getjobslist(ITEMS_PER_PAGE,offset);
      };
      const getjobslist = (ITEMS_PER_PAGE,pageNumber) => {

        var industries_filter:any = [];
        var selected_ind:any = $('#industry_selected').val();
        if (selected_ind != '') {
            var industries_filter = JSON.parse(selected_ind);
        }


        var locations_filter:any = [];
        var selected_loc:any = $('#location_selected').val();
        if (selected_loc != '') {
            var locations_filter = JSON.parse(selected_loc);
        }
var cstatus_val:any = $('#company_status').val();
 setReportStatus(cstatus_val);
 if($('#job_shadow').val() == 'Y'){
  setReportJobShadow('Yes');
} else if($('#job_shadow').val() == 'N') {
  setReportJobShadow('No');
}
else{
  //setReportJobShadow('No');
}
 //setReportLocation($('#location_selfilter').val());
 //setReportIndustry($('#industry_selfilter').val());
 setRunReport('1');

        const requestObject = {
            "industrycategory":industries_filter,
            "companyLocation":locations_filter,
            "siteId":2,
            "jobShadowStatus":$('#job_shadow').val(),
            "status":$('#company_status').val(),
            "searchTxt":$('#job_title').val(),
            "pageSize": ITEMS_PER_PAGE,
            "pageNumber": pageNumber,
            "sortBy": "",
            "sortDir":""
        }
        // console.log(JSON.stringify(objInputAvailableJobs));
        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
          },
          body: JSON.stringify(requestObject)
        };
        $(".load-wrap").show();
        services.getCompanyReportList(requestOptions).then((res) => {
          console.log(JSON.stringify(res.content))
          if (res) {
             //console.log(res.data);
               // $(".paginationContent").show();
                setTotalItems(res.totalElements);
                settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
                setCurrentPage(pageNumber);

                var contAr = res.content;
                //setProfileList(res.content);
                if(res){
                  setJobFilterList(res.content);
                }
                $(".load-wrap").hide();
           }

        });
}

      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Companies Report'})}</PageTitle>


        <div>

      {/* begin::Body */}
      <div>
        {/* begin::Table container */}
        <div className='table-responsive ofx-hidden' style={{minHeight:"600px"}}>


        <form onSubmit={handleSubmit(submitValue)}>
        <div>
          <div className="row">
          <div className="col-lg-12 d-none">
              <div className="mb-10">
              <div className="d-flex justify-content-end">
                    <button type="button" onClick={filterContent_full} className="btn btn-primary my-2" style={{ maxWidth: "200px" }}> Export to Excel</button>
                  </div>
              </div>
            </div>

            <div className="col-lg-12 d-none">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Keyword Search</label>

                </div>
                <input type="text" id="job_title" name="job_title" className="form-control" placeholder=" Search By Company Name/ Email / Company Profile"  />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="form-label">Status</label>

                </div>


                <select className="form-select form-control"  id="company_status" name="company_status" aria-label="Select example" >
                  <option selected value='' className="placeholder">Select...</option>
                  <option value="published">Published</option>
                  <option value="pending">Pending</option>
                </select>

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Job Shadow Opportunity</label>

                </div>
                <select className="form-select form-control" id="job_shadow" name="job_shadow" aria-label="Select example" >
                  <option selected value='' className="placeholder">Select...</option>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">County</label>

                </div>
                <input type="hidden" id="location_selected" />
                <input type="hidden" id="location_selfilter" />
                <ReactSelect
                      //className="form-select"
                      options={mullocationCounty}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}

                      // theme={(theme) => ({
                      //   ...theme,
                      //   borderRadius: 5,
                      //   minHeight: '42px',
                      //   height: '42px',
                      //   colors: {
                      //     ...theme.colors,
                      //     primary25: '#9dcfff',
                      //     primary: '#1e90fd',
                      //     color:"#000",
                      //     color25:"#000",
                      //     border:"0px"
                      //   },

                      // })}
                      onChange={handleChangeForLocation_d}
                      //allowSelectAll={false}
                      value={mullocationCountyselected_d}
                  />
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                <label className=" form-label">Industry Category</label>

                </div>
                <input type="hidden" id="industry_selected" />
                <input type="hidden" id="industry_selfilter" />

                <ReactSelect
                      //className="form-select"
                      options={mulcategories_d}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForCate_d}
                      //allowSelectAll={false}
                      value={optionCatSelected_d}
                      defaultValue={['1']}
                  />
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <div className="d-block">
                    <button type="submit" className="btn btn-primary ml-2 mb-10" style={{ minWidth: "130px" }}>Run Report</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </form>
          {/* begin::Table */}
          <div className="card">
            <div className="card-body px-2 pt-0">

              <div className="d-flex justify-content-end text-right">
           <div className={runReport == '1' ? "tag-wrp" : "tag-wrp d-none"}>
                <div className={reportStatus != '' ? "tag-inn" : ''}><label>{reportStatus != '' ? 'Status : ' : '' }</label>{reportStatus != '' ? reportStatus : '' }</div>

                <div className={reportJobshadow != '' ? "tag-inn" : ''}><label>{reportJobshadow != '' ? 'Job Shadow Opportunity : ' : '' }</label>{reportJobshadow != '' ? reportJobshadow : '' }</div>

                <div className={reportLocation != '' ? "tag-inn" : ''}><label>{reportLocation != '' ? 'County : ' : '' }</label>{reportLocation != '' ? reportLocation : '' }</div>

                <div className={reportIndustry != '' ? "tag-inn" : ''}><label>{reportIndustry != '' ? 'Industry : ' : '' }</label>{reportIndustry != '' ? reportIndustry : '' }</div>
            </div>
           <button type="button" onClick={filterContent_full} className="btn btn-primary my-2 align-self-center" style={{ minWidth: "160px", marginLeft:"auto" }}> Export to Excel</button>
           </div>

              <div className="new-scrl-tbl">
            <div className="dummy" style={{minWidth:"2000px"}}></div>
           </div>
            <div className="new-scrl-tbl2">
              <div className="dummy2">
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 wid '>
            {/* begin::Table head */}
            <thead>
            {/* <tr>
                <td colSpan={'13'}>


                </td>
              </tr> */}
              <tr className='fw-bolder text-muted report-tbl'>
                <th>Name</th>
                <th>Address</th>
                <th>City</th>
                <th>State</th>
                <th>Zip</th>
                <th>County</th>
                <th>Email</th>
                <th>Phone</th>
                <th>WebSite</th>
                <th># Employees</th>
                <th>Job Shadow</th>
                <th>Status</th>
                <th style={{minWidth:"300px",verticalAlign:"baseline", wordBreak:"break-all"}}>Company URL</th>

              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {
	          jobfilterlist.map((data, index) => (
              <tr className="fw-bolder">
                <td style={{minWidth:"200px",verticalAlign:"baseline"}}>{data.companyName}</td>
                <td style={{minWidth:"200px",verticalAlign:"baseline"}}>{data.address1+', '+data.address2}</td>
                <td style={{minWidth:"100px",verticalAlign:"baseline"}}>{data.city}</td>
                <td style={{minWidth:"100px",verticalAlign:"baseline"}}>{data.state}</td>
                <td style={{minWidth:"100px",verticalAlign:"baseline"}}>{data.zip}</td>
                <td style={{minWidth:"100px",verticalAlign:"baseline"}}>{data.countyName}</td>
                <td style={{minWidth:"200px",verticalAlign:"baseline"}}>{data.email}</td>
                <td style={{minWidth:"130px",verticalAlign:"baseline"}}>{data.phone}</td>
                <td style={{minWidth:"200px",verticalAlign:"baseline"}}><a href={data.webSite} target="_blank" >{data.webSite}</a></td>
                <td style={{minWidth:"100px", verticalAlign:"baseline"}}>{data.employeeCount}</td>
                <td style={{minWidth:"100px",verticalAlign:"baseline"}}>{data.jobShadowConcert == 'Y' ? 'Yes' : data.jobShadowConcert == 'N' ? 'No' : '-- '}</td>
                <td style={{minWidth:"100px",verticalAlign:"baseline"}}>{data.status}</td>
                <td style={{minWidth:"300px",verticalAlign:"baseline", wordBreak:"break-all"}}><a href={process.env.React_App_PUBLIC_URL+"companyDetails?companyId="+data.companyId} target="_blank">{process.env.React_App_PUBLIC_URL+"companyDetails?companyId="+data.companyId}</a></td>

              </tr>
              ))}

            </tbody>
            {/* end::Table body */}
          </table>
          </div></div>
          <span className="mb-2 d-block"></span>

          <Pagination

                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />
                 </div></div>

          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      <section className="load-wrap">
          <div className="loadingIcon">
            <img src="/media/icons/duotune/general/loading.gif" className="m-auto"></img>
            <span>Loading... <br /> please be patient..</span>
             </div>
        </section>
      {/* begin::Body */}
    </div>



        </>
      )
    }
export {CompanyReport}